module.exports = __webpack_public_path__ + "static/img/SLAB_OAK.900a559.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/SLAB_OAK.jpg
// module id = /bpN
// module chunks = 0